
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import AuthorizedCredit from '@/extend/classes/AuthorizedCredit';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

@Module({ name: 'storeAuthorizedCredit' })

export default class storeAuthorizedCredit extends VuexModule {
  // States
  private reccords: AuthorizedCredit[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get authorizedCreditLoading (): boolean {
    return this.dataLoading;
  }
  private get authorizedCreditRegistered (): boolean {
    return this.dataRegistered;
  }

  

  public get listAuthorizedCredit (): AuthorizedCredit[] {
    return this.reccords;
  }

  public get listConfigAuthorizedCredit (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mAuthorizedCreditRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mAuthorizedCreditClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mAuthorizedCreditLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mAuthorizedCreditLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(AuthorizedCredit.fromJson(reccord as AuthorizedCredit));
    })
    AuthorizedCredit.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mAuthorizedCreditConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mAuthorizedCreditCreated (obj: AuthorizedCredit): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAuthorizedCredit(obj)) {
          api.fromAuthorizedCredit(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareAuthorizedCredit(obj)) {
            api.fromAuthorizedCredit(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mAuthorizedCreditUpdated (obj: AuthorizedCredit): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAuthorizedCredit(obj)) {
          api.fromAuthorizedCredit(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mAuthorizedCreditDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerAuthorizedCredit (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.authorizedCreditRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerAuthorizedCredit(this.authorizedCreditCreated, this.authorizedCreditUpdated, this.authorizedCreditDeleted);
          this.mAuthorizedCreditRegistered();
        } else {
          setTimeout(() => resolve(this.registerAuthorizedCredit(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.authorizedCreditLoading && !this.authorizedCreditLoaded) {
          this.mAuthorizedCreditLoading(true);
          return AuthorizedCredit.list(filter)
            .then((data: ListData) => {
              this.mAuthorizedCreditLoaded(data);
              this.mAuthorizedCreditLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredAuthorizedCredit (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.authorizedCreditLoading) {
        this.mAuthorizedCreditLoading(true);
        return AuthorizedCredit.list(filter)
          .then((data: ListData) => {
            this.mAuthorizedCreditLoaded(data);
            this.mAuthorizedCreditLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  private authorizedCreditCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAuthorizedCreditConfigUpdated(config)
    const obj = objConfig.obj as AuthorizedCredit;
    this.mAuthorizedCreditCreated(AuthorizedCredit.fromJson(obj));
  }

  @Action
  private authorizedCreditUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAuthorizedCreditConfigUpdated(config)
    const obj = objConfig.obj as AuthorizedCredit;
    this.mAuthorizedCreditUpdated(AuthorizedCredit.fromJson(obj));
  }

  @Action
  private authorizedCreditDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as AuthorizedCredit;
    this.mAuthorizedCreditDeleted(obj.id);
  }
}
